module.exports = new __parcel__URL__("invoicePayInfographic-old.4c3c5aa0.png").toString();